import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { countryService } from "../service/country.service";
import { userService } from "../service/user.service";
import "./ContactUs.css";

const ContactUs: React.FC = () => {
  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated
  );
  const clientName = useSelector((state: any) => state.auth.clientName) ?? "";

  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    country: "",
    interestedIn: "",
    phone: "",
    message: "",
  });
  const [countries, setCountries] = useState<{ id: number; name: string }[]>(
    []
  );

  // Fetch user details and pre-fill form if authenticated
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!isAuthenticated) return;

      try {
        const userData = await userService.getCurrentUserDetails();
        const firstName = userData.firstName || "";
        const lastName = userData.lastName || "";
        const fullName = `${firstName} ${lastName}`.trim();

        // Fetch country name if countryId is available
        let countryName = "";
        if (
          userData.address &&
          Array.isArray(userData.address) &&
          userData.address.length > 0
        ) {
          const firstAddress = userData.address[0];
          const countryId = firstAddress.countryId;
          if (countryId) {
            try {
              const countriesData = await countryService.getAll();
              const country = countriesData.find(
                (c: any) => c.id === countryId
              );
              countryName = country?.name || "";
            } catch (error) {
              console.error("Error fetching countries:", error);
            }
          }
        }

        setForm((prev) => ({
          ...prev,
          name: fullName || prev.name,
          email: userData.email || prev.email,
          phone: String(userData.phoneNumber || userData.phone || prev.phone),
          country: countryName || prev.country,
          company: clientName || prev.company,
        }));
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, [isAuthenticated, clientName]);

  const interestedInOptions = [
    { label: "Interested In", value: "" },
    { label: "Immigration", value: "immigration" },
    { label: "Corporate housing", value: "Corporate housing" },
    { label: "Customized solutions", value: "Customized solutions" },
  ];

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // You can handle the form submission here (e.g., send to API)
    alert("Enquiry submitted!");
    setForm({
      name: "",
      email: "",
      company: "",
      country: "",
      interestedIn: "",
      phone: "",
      message: "",
    });
  };

  return (
    <>
      <div className="inner-hero">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 text-center py-5">
              <h1 className="display-4">Contact Us</h1>
              <p className="lead">Start Your Journey, with Us</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container contact-us-form-container">
        <div className="row g-4 align-items-start">
          {/* Right Side - Contact Form */}
          <div className="col-lg-7">
            <div className="card contact-us-card">
              <div className="card-body">
                <div className="contact-us-form-header">
                  <Icon.EnvelopeFill className="me-2 text-success" size={18} />
                  <h4 className="mb-0">Contact Enquiry Form</h4>
                </div>
                <p className="contact-us-form-description">
                  Fill out the form below and our team will get back to you with
                  the details.
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="row g-2">
                    <div className="col-md-6 form-group">
                      <div className="d-flex flex-column gap-1">
                        <label htmlFor="name">
                          <Icon.Person className="me-1" size={12} />
                          Name
                        </label>
                        <InputText
                          id="name"
                          name="name"
                          placeholder="Enter your Name"
                          value={form.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6 form-group">
                      <div className="d-flex flex-column gap-1">
                        <label htmlFor="email">
                          <Icon.Envelope className="me-1" size={12} />
                          Email ID
                        </label>
                        <InputText
                          type="email"
                          id="email"
                          name="email"
                          placeholder="Enter your Email ID"
                          value={form.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6 form-group">
                      <div className="d-flex flex-column gap-1">
                        <label htmlFor="companyname">
                          <Icon.Building className="me-1" size={12} />
                          Company Name
                        </label>
                        <InputText
                          id="companyname"
                          type="text"
                          name="company"
                          placeholder="Enter your company Name"
                          value={form.company}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 form-group">
                      <div className="d-flex flex-column gap-1">
                        <label htmlFor="country">
                          <Icon.GeoAlt className="me-1" size={12} />
                          Country
                        </label>
                        <InputText
                          type="text"
                          id="country"
                          name="country"
                          placeholder="Enter your Country"
                          value={form.country}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 form-group">
                      <div className="d-flex flex-column gap-1">
                        <label htmlFor="interestedIn">
                          <Icon.StarFill className="me-1" size={12} />
                          Interested in
                        </label>
                        <Dropdown
                          value={form.interestedIn}
                          onChange={(e) =>
                            setForm({ ...form, interestedIn: e.value })
                          }
                          options={interestedInOptions}
                          id="interestedIn"
                          name="interestedIn"
                          placeholder="Select an Option"
                          appendTo="self"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 form-group">
                      <div className="d-flex flex-column gap-1">
                        <label htmlFor="phone">
                          <Icon.Telephone className="me-1" size={12} />
                          Phone (International numbers)
                        </label>
                        <InputText
                          type="tel"
                          id="phone"
                          name="phone"
                          placeholder="Enter your Phone Number"
                          value={form.phone}
                          onChange={handleChange}
                          pattern="^\+?[0-9\s\-()]{7,}$"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-12 form-group">
                      <div className="d-flex flex-column gap-1">
                        <label htmlFor="message">
                          <Icon.ChatDots className="me-1" size={12} />
                          Message
                        </label>

                        <InputTextarea
                          id="message"
                          name="message"
                          placeholder="Tell us how we can help you..."
                          rows={3}
                          value={form.message}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button type="reset" className="btn btn-secondary">
                      <Icon.XCircle className="me-1" size={14} />
                      Clear
                    </Button>
                    <Button type="submit" className="btn btn-primary">
                      <Icon.SendFill className="me-1" size={14} />
                      Submit
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* Left Side - SVG Image */}
          <div className="col-lg-5 d-none d-lg-block">
            <div className="contact-us-illustration">
              <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
                {/* Background Circle */}
                <circle
                  cx="250"
                  cy="250"
                  r="200"
                  fill="#f0f9ff"
                  opacity="0.5"
                />

                {/* Building/House */}
                <rect
                  x="150"
                  y="180"
                  width="200"
                  height="180"
                  fill="#28a745"
                  rx="10"
                />
                <rect
                  x="165"
                  y="200"
                  width="60"
                  height="50"
                  fill="#ffffff"
                  rx="5"
                />
                <rect
                  x="275"
                  y="200"
                  width="60"
                  height="50"
                  fill="#ffffff"
                  rx="5"
                />
                <rect
                  x="165"
                  y="270"
                  width="60"
                  height="50"
                  fill="#ffffff"
                  rx="5"
                />
                <rect
                  x="275"
                  y="270"
                  width="60"
                  height="50"
                  fill="#ffffff"
                  rx="5"
                />
                <rect x="210" y="300" width="80" height="60" fill="#20c997" />

                {/* Roof */}
                <path d="M 130 180 L 250 120 L 370 180 Z" fill="#1e7e34" />

                {/* Support Person */}
                <circle cx="100" cy="220" r="30" fill="#e91e63" />
                <ellipse cx="100" cy="280" rx="35" ry="50" fill="#f06292" />

                {/* Headset */}
                <path
                  d="M 80 210 Q 75 220 80 230"
                  stroke="#ffffff"
                  strokeWidth="4"
                  fill="none"
                />
                <path
                  d="M 120 210 Q 125 220 120 230"
                  stroke="#ffffff"
                  strokeWidth="4"
                  fill="none"
                />
                <line
                  x1="80"
                  y1="220"
                  x2="120"
                  y2="220"
                  stroke="#ffffff"
                  strokeWidth="3"
                />

                {/* Communication Icons */}
                <circle cx="400" cy="150" r="25" fill="#00acc1" opacity="0.8" />
                <path
                  d="M 390 145 L 395 150 L 410 135"
                  stroke="#ffffff"
                  strokeWidth="3"
                  fill="none"
                />

                <circle cx="420" cy="250" r="20" fill="#e91e63" opacity="0.8" />
                <path
                  d="M 410 250 L 430 250 M 420 240 L 420 260"
                  stroke="#ffffff"
                  strokeWidth="3"
                />

                <circle cx="390" cy="330" r="22" fill="#28a745" opacity="0.8" />
                <text
                  x="380"
                  y="340"
                  fill="#ffffff"
                  fontSize="24"
                  fontWeight="bold"
                >
                  ?
                </text>

                {/* Decorative Elements */}
                <circle cx="60" cy="120" r="8" fill="#28a745" opacity="0.6" />
                <circle cx="440" cy="400" r="10" fill="#e91e63" opacity="0.6" />
                <circle cx="80" cy="380" r="6" fill="#00acc1" opacity="0.6" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
